import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm">分类浏览，精准吃瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 bg-background-50 rounded-2xl p-4 border border-background-200/60 cursor-pointer hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-800 font-bold text-sm truncate">{item.title}</h3>
                <p className="text-foreground-400 text-xs mt-0.5">{item.count} 篇内容</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 text-lg"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}